import API from "@lib/axiosConfig";

export default (url, body) => API.post(url, body);
